module.exports = __webpack_public_path__ + "static/img/course2.f00f6c0c.png";